export default "__VITE_ASSET__bp$ORMmO__"